<button mat-raised-button color="color" [disabled]="disabled" (click)="onClick()">
  <mat-icon *ngIf="fontSet && fontIcon && !faIcon" [fontSet]="fontSet" [fontIcon]="fontIcon"></mat-icon>
  <fa-icon *ngIf="faIcon" [icon]="faIcon"></fa-icon>
  <span *ngIf="label">{{label}}</span>
</button>
